module.exports = __webpack_public_path__ + "static/media/number-arrow.f03e8f2c.svg";